import api from '@api/Api';

export default {

    getCustomer(id) {
        return api().get(`/customers/${id}`);
    },

    deleteCustomer(id) {
        return api().delete(`/customers/${id}`);
    },

    updateTrait(id, params) {
        return api().put(`/customers/${id}/traits`, params);
    },

    getEvents(id, params) {
        return api().get(`/customers/${id}/events`, { params: params });
    },

    deleteEvent(id, customer_event_id) {
        return api().delete(`/customers/${id}/events/${customer_event_id}`);
    },

    getPages(id, params) {
        return api().get(`/customers/${id}/pages`, { params: params });
    },

    deletePage(id, customer_page_id) {
        return api().delete(`/customers/${id}/pages/${customer_page_id}`);
    },

    getCharges(id, params) {
        return api().get(`/customers/${id}/charges`, { params: params });
    },

    deleteCharge(id, customer_charge_id) {
        return api().delete(`/customers/${id}/charges/${customer_charge_id}`);
    },

    unsubscribe(id, params) {
        return api().post(`/customers/${id}/unsubscribe`, params);
    },

    updateTags(id, params) {
        return api().put(`/customers/${id}/tags`, params);
    },

    updateNotes(id, params) {
        return api().put(`/customers/${id}/notes`, params);
    },

}
